import React from "react";

import { cn } from "../../utils/cn";

export interface RailHeaderProps {
    /** Left slot — typically an item count. */
    count?: React.ReactNode;
    /** Right slot — typically the primary action (e.g. a create button). */
    action?: React.ReactNode;
    /** Extend / override the header chrome (default `px-4 py-5`). */
    className?: string;
}

/**
 * RailHeader — the top row of a list rail: a left slot (typically a
 * count) and a right slot (typically a create / primary action), laid
 * out as a spaced row.
 *
 * Generic Component: it knows no Solomon/YaaS entity. Both slots take
 * `ReactNode` — the domain passes its count + action in, so this header
 * never imports a Domain Component.
 *
 * @see RailHeader.intent.md   policy + recipes
 * @see RailHeader.layout.html intended layout
 */
export function RailHeader({
    count,
    action,
    className
}: RailHeaderProps): React.ReactElement {
    return (
        <div
            className={cn(
                "px-4 py-5 flex items-center justify-between gap-4",
                className
            )}
        >
            <div className="min-w-0">{count}</div>
            {action}
        </div>
    );
}
